class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.button = this.closest("button");
    this.form = this.button?.form;

    if (!this.form) return;

    this.onSubmit = (e) => {
      e.preventDefault();

      if (e.target.querySelector("[data-option-indeterminate]")) return;

      const formData = new FormData(this.form);

      const data = {};

      // Add each name/value pair to the object
      for (const [name, value] of formData) {
        data[name] = value;
      }

      if (!("quantity" in data)) {
        data.quantity = 1;
      }

      // // Return the JSON string
      // return JSON.stringify(pairs);

      window.addToCart(data, {
        onAfterAdd: () => {
          document.dispatchEvent(new CustomEvent("mini-cart:open"));
        },
      });
    };

    this.form.addEventListener("submit", this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }
}

if (!customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCart);
}
